import { Square } from '@mui/icons-material';
import { Box } from '@ovComponents/1-primative/box/box';
import { colorToHexWithAlpha } from '@utils/formatting';
import { useState } from 'react';
import { ChromePicker } from 'react-color';
import { InputAdornment, TextField } from '../textField/textField';

type ColorPickerFieldProps = {
  label: string;
  value: string;
  onChange: (event: any) => void;
  fullWidth?: boolean;
  testId?: string;
  error?: boolean;
  errorText?: string;
  onBlur?: () => void;
  showAlpha?: boolean;
};
export const ColorPickerField = (props: ColorPickerFieldProps) => {
  const [open, setOpen] = useState(false);
  const style = {
    popover: {
      position: 'absolute',
      zIndex: '2',
      left: '10px',
      top: '60px',
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <TextField
        label={props.label}
        fullWidth={props.fullWidth}
        value={props.value}
        onClick={handleClickOpen}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Square style={{ color: props.value }} />
            </InputAdornment>
          ),
        }}
        onChange={(e: any) => {
          props.onChange(e.target.value);
        }}
        testId={props.testId}
        error={props.error}
        errorText={props.errorText}
        onBlur={props.onBlur}
      />
      {open && (
        <Box sx={style.popover}>
          <Box sx={style.cover} onClick={handleClose} />
          <ChromePicker
            color={props.value}
            onChangeComplete={(e) => {
              props.onChange(colorToHexWithAlpha(e));
            }}
            disableAlpha={props.showAlpha === false}
          />
        </Box>
      )}
    </Box>
  );
};
